import { render, staticRenderFns } from "./IgnoreWebOrders.vue?vue&type=template&id=73ee6ca6"
import script from "./IgnoreWebOrders.vue?vue&type=script&lang=js"
export * from "./IgnoreWebOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports